import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { Task } from "@recobra/schemas/task";

import { TruncatedText } from "../../lib";
import { useTaskLabels } from "../task-data";
import { TaskModalSection, TaskSummaryList, TaskSummaryRow } from "../task-display";

/**
 * The activities resolved before this one, numbered oldest first, each with its
 * resolution and, below it, its note, so whoever picks this one up reads the
 * trail without leaving the modal. Absent for callers the API doesn't hand other
 * actors' activities to.
 */
export const TaskPreviousActivitySummary: FC<{ task: Task }> = ({ task }) => {
  const activities = task.previousActivities ?? [];
  const { taskName, resolutionLabel } = useTaskLabels();
  if (activities.length === 0) return null;

  return (
    <TaskModalSection>
      <TaskSummaryList multiline>
        {activities.map(({ taskId, type, solution, notes }, index) => (
          <TaskSummaryRow key={taskId} label={m.task_previous_activity_label({ index: index + 1 })}>
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="flex min-w-0 items-center gap-2">
                <TruncatedText text={taskName(type)} />
                {solution ? (
                  <TruncatedText
                    text={resolutionLabel(type, solution)}
                    className="text-muted-foreground"
                  />
                ) : null}
              </div>
              {notes ? <TruncatedText text={notes} className="text-muted-foreground" /> : null}
            </div>
          </TaskSummaryRow>
        ))}
      </TaskSummaryList>
    </TaskModalSection>
  );
};
